import { Route, Routes } from 'react-router-dom';
import DiscountsPage from '../pages/discounts-page';
import DiscountFormPage from '../pages/discount-form-page';

export const DiscountsRoutes = () => {
  return (
    <Routes>
      <Route index element={<DiscountsPage />} />
      <Route path="new" element={<DiscountFormPage />} />
      <Route path=":id" element={<DiscountFormPage />} />
    </Routes>
  );
};

export default DiscountsRoutes;
